// Require

const { id, log, min, max, percent, floor } = require("../std/index")

const { Slice } = require("./master")


//
// "Which Casing" Slice
//

module.exports = class NaturalSlice extends Slice {
  constructor($host, config) {
    super($host, config);

    this.stagger = 0.1;

    this.dom.rule = $('.rule', $host);
    this.dom.leftParts = $('.left .part', $host);
    this.dom.rightParts = $('.right .part', $host);
    this.dom.greenRules = $('.green-bullet', $host);
    this.dom.button = $('.button', $host);

    this.tween = this.prepareTween();
  }

  prepareTween(d = this.stagger) {
    const tl = new TimelineLite({ paused: true });
    tl.fromTo(this.dom.rule, 0.8, { width: '100%' }, { width: '0%', ease: Power4.easeOut }, 0);
    tl.fromTo(this.dom.rule, 0.5, { autoAlpha: 1 }, { autoAlpha: 0 }, 0.2);

    for (let i = 0; i < this.dom.leftParts.length; i++) {
      if (i !== 1) {
        const leftPart = this.dom.leftParts[i];
        const y = i - 1;
        tl.fromTo(leftPart, 0.8,
          { autoAlpha: 0, y: 100 * y },
          { autoAlpha: 1, y: 0, ease: Power3.easeOut }, 0.1);
      }
    }

    for (let i = 0; i < this.dom.rightParts.length; i++) {
      const rightPart = this.dom.rightParts[i];
      const y = i - 1.5;
      tl.fromTo(rightPart, 0.8,
        { autoAlpha: 0, y: 100 * y },
        { autoAlpha: 1, y: 0, ease: Power3.easeOut }, 0.1);
    }

    for (let i = 0; i < this.dom.greenRules.length; i++) {
      const rule = this.dom.greenRules[i];
      const y = i - 0.5;
      tl.fromTo(rule, 0.8,
        { autoAlpha: 0, y: 400 * y },
        { autoAlpha: 1, y: 0, ease: Power1.easeOut }, 0.2);
    }

    tl.fromTo(this.dom.button, 0.5, { autoAlpha: 0, y: 100 }, { autoAlpha: 1, y: 0 }, 0.5);

    return tl;
  }

  onProgress(p) {
    this.tween.seek(min(1, p));
  }
};
